import React from "react";
import { useState } from "react";
import CloseIcon from "@material-ui/icons/Close";
import "../assets/styles/Galler.css";
import Img1 from "../assets/images/Gallery/img1.jpg";
import Img2 from "../assets/images/Gallery/img2.jpg";
import Img3 from "../assets/images/Gallery/img3.jpg";
import Img4 from "../assets/images/Gallery/img4.jpg";
import Img5 from "../assets/images/Gallery/img5.jpg";
import Img6 from "../assets/images/Gallery/img6.jpg";
import Img7 from "../assets/images/Gallery/img7.jpg";
import Img8 from "../assets/images/Gallery/img8.jpg";
import Img9 from "../assets/images/Gallery/img9.jpg";
import Img10 from "../assets/images/Gallery/img10.jpg";
import Img11 from "../assets/images/Gallery/img11.jpg";
const Gallery = () => {
  let data = [
    {
      id: 1,
      imgSrc: Img1,
    },
    {
      id: 2,
      imgSrc: Img2,
    },
    {
      id: 3,
      imgSrc: Img3,
    },
    {
      id: 4,
      imgSrc: Img4,
    },
    {
      id: 5,
      imgSrc: Img5,
    },
    {
      id: 6,
      imgSrc: Img6,
    },
    {
      id: 7,
      imgSrc: Img7,
    },
    {
      id: 8,
      imgSrc: Img8,
    },
    {
      id: 9,
      imgSrc: Img9,
    },
    {
      id: 10,
      imgSrc: Img10,
    },
    {
      id: 11,
      imgSrc: Img11,
    },
  ];
  const [model, setModel] = useState(false);
  const [tempimgSrc, setTempImgSrc] = useState("");
  const getImg = (imgSrc) => {
    setTempImgSrc(imgSrc);
    setModel(true);
  };
  return (
    <div className="galBody">
      <h1 style={{ textAlign: "center" }}>Image Gallery</h1>
      <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt={model} />
        <CloseIcon
          onClick={() => {
            setModel(false);
          }}
        />
      </div>
      <div className="gallery">
        {data.map((item, index) => {
          return (
            <div
              className="pics"
              key={index}
              onClick={() => {
                getImg(item.imgSrc);
              }}
            >
              <img src={item.imgSrc} alt={item.id} style={{ width: "100%" }} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Gallery;
